export default function ($state) {
    return {
        restrict: 'A',
        scope: {
            highlightWhenChildOf: '@'
        },
        link($scope, $el) {
            $scope.$on('$stateChangeSuccess', () => {
                const enabledActiveClass = $state.includes(`${ $scope.highlightWhenChildOf }.**`);
                $el.toggleClass('active', enabledActiveClass);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/highlightWhenChildOf.js